/**
 * Presentment-aware money formatting for Shopify Markets.
 * Uses Shopify.money_format (set per visitor currency) with shop-currency fallbacks.
 */
(function () {
  'use strict';

  function cfg() {
    return window.SwoopMoney || {};
  }

  function activeMoneyFormat() {
    if (window.Shopify && Shopify.money_format) return Shopify.money_format;
    return cfg().moneyFormat || '${{amount}}';
  }

  function presentmentRate() {
    if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
      var live = parseFloat(Shopify.currency.rate, 10);
      if (!isNaN(live) && live > 0) return live;
    }
    var fallback = cfg().presentmentRate;
    if (typeof fallback === 'number' && fallback > 0) return fallback;
    return 1;
  }

  function needsConversion() {
    return !!cfg().needsConversion;
  }

  function normalizeCents(cents, fromShopCurrency) {
    var n = Number(cents);
    if (isNaN(n)) return 0;
    if (fromShopCurrency || (needsConversion() && cfg().variantPricesInShopCurrency)) {
      return Math.round(n * presentmentRate());
    }
    return Math.round(n);
  }

  function fallbackFormat(cents, fmt) {
    var abs = Math.abs(cents);
    var main = String(Math.floor(abs / 100));
    var frac = ('0' + (abs % 100)).slice(-2);
    var withDot = main + '.' + frac;
    var withComma = main + ',' + frac;
    return (fmt || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/gi, main)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/gi, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, main)
      .replace(/\{\{\s*amount\s*\}\}/gi, withDot);
  }

  function format(cents, opts) {
    opts = opts || {};
    var amount = normalizeCents(cents, !!opts.fromShopCurrency);
    var fmt = activeMoneyFormat();
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(amount, fmt);
    }
    return fallbackFormat(amount, fmt);
  }

  function activeCurrencyCode() {
    if (cfg().activeCurrency) return String(cfg().activeCurrency).toUpperCase();
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return String(Shopify.currency.active).toUpperCase();
    }
    return String(cfg().shopCurrency || 'USD').toUpperCase();
  }

  function parseEditorPriceCents(str) {
    if (!str) return 0;
    var n = parseFloat(String(str).replace(/[^0-9.]/g, ''), 10);
    return isNaN(n) ? 0 : Math.round(n * 100);
  }

  /** USD/EUR editor amounts (cents) → presentment cents for the active currency. */
  function resolveEditorPriceCents(usdCents, eurCents) {
    usdCents = Number(usdCents) || 0;
    eurCents = Number(eurCents) || 0;
    var cur = activeCurrencyCode();
    if (cur === 'EUR' && eurCents > 0) return eurCents;
    if (cur === 'USD' && usdCents > 0) return usdCents;
    if (usdCents > 0) return normalizeCents(usdCents, true);
    if (eurCents > 0) return eurCents;
    return 0;
  }

  window.SwoopMoney = window.SwoopMoney || {};
  window.SwoopMoney.format = format;
  window.SwoopMoney.convertShopCents = function (cents) {
    return normalizeCents(cents, true);
  };
  window.SwoopMoney.parseEditorPriceCents = parseEditorPriceCents;
  window.SwoopMoney.resolveEditorPriceCents = resolveEditorPriceCents;
  window.SwoopMoney.presentmentRate = window.SwoopMoney.presentmentRate || 1;
})();
